var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.loadComponent(_vm.type),{tag:"component",attrs:{"type":_vm.type,"id":_vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }